import { motion } from 'framer-motion';

function ItSolutions() {
  return (
    <div className="mt-3 pt-5 pt-lg-0">
      <motion.h2
        className="fw-semibold"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Necessiti di Servizi IT?
      </motion.h2>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Soluzioni IT concrete, testate sul campo.
        Tecnologia che funziona, perché prima di venderla… la usiamo noi.
        In Greenia crediamo che la tecnologia debba essere utile prima che bella, accessibile prima che sofisticata. Per questo ogni soluzione che proponiamo nasce da un bisogno reale, viene sviluppata internamente, testata nei nostri flussi assicurativi e solo dopo viene resa disponibile alle aziende. Non vendiamo “idee”, ma strumenti di lavoro solidi, collaudati, personalizzabili.
        {' '}
        <b>Il nostro approccio è semplice:</b>
        {' '}
        ascoltiamo le esigenze, analizziamo i flussi, costruiamo soluzioni.
        Che tu sia un’intermediazione assicurativa, una compagnia, o un’impresa commerciale in cerca di maggiore efficienza, Greenia è il partner tecnologico che lavora come un’estensione della tua squadra.
      </motion.p>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.4, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Due anime, una visione:</b>
      </motion.p>
      <ul>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
        >
          <b>IT as a Service:</b>
          {' '}
          infrastruttura, piattaforme, automazioni e integrazioni già pronte all’uso, ideali per chi vuole partire subito con soluzioni affidabili e aggiornate.
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          <b>Sviluppo su misura:</b>
          {' '}
          progetti disegnati intorno al tuo modello di business, con un team interno di sviluppo e consulenza che ti accompagna dall’idea alla delivery.
        </motion.li>
      </ul>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.7, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Un ecosistema pensato per creare valore:</b>
      </motion.p>
      <ul>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
        >
          <b>Piattaforme digitali customizzabili</b>
          {' '}
          (CRM, aree riservate, gestione documentale, sistemi di preventivazione, portali clienti)
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          <b>Integrazione AI e automazioni operative</b>
          {' '}
          (bot conversazionali, estrazione dati da documenti, workflow intelligenti)
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          <b>Soluzioni API-ready</b>
          {' '}
          (perfette per essere integrate nei tuoi sistemi esistenti, in logica plug-and-play)
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          <b>Ambiente serverless e scalabilità nativa</b>
          {' '}
          (riduci i costi fissi e cresci solo quando serve)
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          <b>UI/UX design funzionale e minimal</b>
          {' '}
          ( (per far usare davvero le soluzioni che sviluppiamo))
        </motion.li>
      </ul>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.8, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>
          Perché sceglierci:
        </b>
      </motion.p>
      <ul>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.9, duration: 0.5, ease: 'linear' }}
        >
          Siamo
          {' '}
          <b>intermediari assicurativi</b>
          {' '}
          prima ancora che sviluppatori: conosciamo il business, non solo il codice.
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1, duration: 0.5, ease: 'linear' }}
        >
          I nostri strumenti sono
          {' '}
          <b>fatti per chi lavora</b>
          , non per collezionare funzionalità inutili.
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1.1, duration: 0.5, ease: 'linear' }}
        >
          Tutto ciò che proponiamo
          {' '}
          <b>è già attivo nei nostri processi interni:</b>
          {' '}
          sappiamo come farlo funzionare perché lo viviamo ogni giorno.
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1.2, duration: 0.5, ease: 'linear' }}
        >
          Siamo
          {' '}
          <b>un team compatto, reattivo e presente:</b>
          {' '}
          lavoriamo a stretto contatto con i tuoi referenti e siamo ossessionati dalla qualità.
        </motion.li>
      </ul>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1.3, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Greenia non è un fornitore, è un partner operativo. Ci innamoriamo dei problemi, non delle soluzioni. E se non serve tecnologia, siamo i primi a dirtelo.
      </motion.p>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1.4, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Scrivi, sarai presto ricontattato
        {' '}
        <a href="mailto:amministrazione@greenia.it">amministrazione@greenia.it</a>
      </motion.p>
    </div>
  );
}

export default ItSolutions;
